var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1205,
    height: 632,
    viewBox: "0 0 1205 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.805 320.872L505.42 363.315L679.174 262.51L602.908 220.067L431.805 320.872Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.805 545.021L505.42 587.463L679.174 486.666L602.908 444.224L431.805 545.021Z",
    stroke: "#231F20",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432.227 545.021L505.842 587.463L679.588 486.666L603.33 444.224L432.227 545.021Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M505.422 363.314V587.463",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M602.242 220.067V444.224L679.096 486.587V262.438",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M431.805 320.135V544.283",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431.805 441.311L505.42 483.753L679.174 382.948L602.908 340.506L431.805 441.311Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M432.227 545.021L505.842 587.463L679.588 486.666L603.33 444.224L432.227 545.021Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M505.422 483.753V587.47",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M431.805 440.573V546.973",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M504.488 483.881L578.104 526.324L751.858 425.519L675.591 383.076L504.488 483.881Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M504.91 587.591L578.526 630.033L752.272 529.236L676.013 486.794L504.91 587.591Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M578.105 526.323V630.033",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M750.453 424.574V528.284",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M504.488 483.144V589.543",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M345.155 318.873L271.547 361.324L97.793 260.519L174.059 218.076L345.155 318.873Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M345.155 543.029L271.547 585.472L97.793 484.667L174.059 442.225L345.155 543.029Z",
    stroke: "#231F20",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M344.741 543.029L271.125 585.472L97.3711 484.667L173.637 442.225L344.741 543.029Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M271.543 361.323V585.472",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M174.717 218.076V442.225L97.8633 484.596V260.447",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M345.152 318.144V542.292",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "5.75 5.75"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3 319.832L76.6156 362.275L250.369 261.47L174.103 219.027L3 319.832Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3 543.981L76.6156 586.431L250.369 485.626L174.103 443.184L3 543.981Z",
    stroke: "#231F20",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42188 543.981L77.0375 586.431L250.783 485.626L174.525 443.184L3.42188 543.981Z",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6172 362.274V586.431",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M173.438 219.027V443.184L250.291 485.555V261.398",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3 319.094V543.25",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M872 1V571",
    stroke: "white",
    strokeWidth: 1.65865,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M938 0V571",
    stroke: "white",
    strokeWidth: 1.65865,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1002 4V571",
    stroke: "white",
    strokeWidth: 1.65072,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1062 1V571",
    stroke: "white",
    strokeWidth: 1.65865,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1126 1V571",
    stroke: "white",
    strokeWidth: 1.65865,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1186 0V571",
    stroke: "white",
    strokeWidth: 1.65865,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M872.597 521.277C882.691 521.277 890.874 513.094 890.874 503C890.874 492.906 882.691 484.723 872.597 484.723C862.503 484.723 854.32 492.906 854.32 503C854.32 513.094 862.503 521.277 872.597 521.277Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M936.964 455.866C947.059 455.866 955.241 447.683 955.241 437.589C955.241 427.495 947.059 419.312 936.964 419.312C926.87 419.312 918.688 427.495 918.688 437.589C918.688 447.683 926.87 455.866 936.964 455.866Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.34 279.359C1011.44 279.359 1019.62 271.176 1019.62 261.082C1019.62 250.988 1011.44 242.805 1001.34 242.805C991.249 242.805 983.066 250.988 983.066 261.082C983.066 271.176 991.249 279.359 1001.34 279.359Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.93 347.879C1136.03 347.879 1144.21 339.696 1144.21 329.602C1144.21 319.508 1136.03 311.325 1125.93 311.325C1115.84 311.325 1107.66 319.508 1107.66 329.602C1107.66 339.696 1115.84 347.879 1125.93 347.879Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.52 316.737C1070.62 316.737 1078.8 308.555 1078.8 298.461C1078.8 288.366 1070.62 280.184 1060.52 280.184C1050.43 280.184 1042.25 288.366 1042.25 298.461C1042.25 308.555 1050.43 316.737 1060.52 316.737Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.15 438.208C1196.25 438.208 1204.43 430.025 1204.43 419.931C1204.43 409.837 1196.25 401.654 1186.15 401.654C1176.06 401.654 1167.88 409.837 1167.88 419.931C1167.88 430.025 1176.06 438.208 1186.15 438.208Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M872.598 502.998L936.968 437.589L1001.35 261.081L1126.45 334.8L1186.15 419.931",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M872.598 334.8L936.968 269.382L999.782 181.648L1126.45 222.147L1186.15 251.732",
    stroke: "white",
    strokeWidth: 2.07927,
    strokeMiterlimit: 10,
    strokeDasharray: "4.76 4.76"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M872.597 353.077C882.691 353.077 890.874 344.894 890.874 334.8C890.874 324.706 882.691 316.523 872.597 316.523C862.503 316.523 854.32 324.706 854.32 334.8C854.32 344.894 862.503 353.077 872.597 353.077Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.03963,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M936.964 287.66C947.059 287.66 955.241 279.477 955.241 269.383C955.241 259.289 947.059 251.106 936.964 251.106C926.87 251.106 918.688 259.289 918.688 269.383C918.688 279.477 926.87 287.66 936.964 287.66Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.03963,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M999.781 199.926C1009.87 199.926 1018.06 191.743 1018.06 181.649C1018.06 171.555 1009.87 163.372 999.781 163.372C989.687 163.372 981.504 171.555 981.504 181.649C981.504 191.743 989.687 199.926 999.781 199.926Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.03963,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.45 240.423C1136.54 240.423 1144.73 232.24 1144.73 222.146C1144.73 212.052 1136.54 203.869 1126.45 203.869C1116.35 203.869 1108.17 212.052 1108.17 222.146C1108.17 232.24 1116.35 240.423 1126.45 240.423Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.03963,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 221.734C1070.09 221.734 1078.28 213.551 1078.28 203.457C1078.28 193.363 1070.09 185.18 1060 185.18C1049.91 185.18 1041.72 193.363 1041.72 203.457C1041.72 213.551 1049.91 221.734 1060 221.734Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.03963,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.15 270.01C1196.25 270.01 1204.43 261.827 1204.43 251.733C1204.43 241.639 1196.25 233.456 1186.15 233.456C1176.06 233.456 1167.88 241.639 1167.88 251.733C1167.88 261.827 1176.06 270.01 1186.15 270.01Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 1.03963,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.a9b521d276e3433cb90fdc3840810b7e.svg";
export { ForwardRef as ReactComponent };